import { useTranslation } from "react-i18next";
import { DataTable } from "../../../../shared/components/data-table/DataTable";
import SectionTitleCell from "../shared/SectionTitleCell";
import SectionIconCell from "../shared/SectionIconCell";

const DashboardsOverviewTable = ({ data }) => {
  const { t } = useTranslation();

  const columns = [
    {
      accessorKey: "icon",
      header: "",
      cell: ({ row }) => {
        const data = row.original;
        return <SectionIconCell icon={data.type.icon} />;
      },
    },
    {
      accessorKey: "title",
      header: t("dashboards.overview.table.header.title"),
      cell: ({ row }) => <SectionTitleCell data={row.original} />,
    },
    {
      accessorKey: "description",
      header: () => (
        <div className="hidden sm:table-cell">
          {t("dashboards.overview.table.header.description")}
        </div>
      ),
      cell: ({ row }) => (
        <div className="hidden sm:table-cell">
          {t(row.getValue("description"))}
        </div>
      ),
    },
  ];

  return <DataTable columns={columns} data={data} />;
};

export default DashboardsOverviewTable;
